<div class="all">
  @if (aktiivinenValilehti == 0) {
    <div class="sisalto">
      <div class="containerii" style="margin-top: 2em">
        <div class="keskitettava">
          <div class="light-blue-text otsikko" style="margin-top: 0">{{ 'lasku.laheta-comp.email.otsikko' | translate | async }}</div>
          <div class="light-gray-text ohjeteksti">
            {{ 'lasku.laheta-comp.email.' + infotekstinAvain | translate | async }}
          </div>
          @if (onkoMuistutus && !onkoUudelleenlahetys) {
            <div style="padding-bottom: 1em">
              <form>
                <div style="display: flex; flex-flow: row wrap; justify-content: left; align-items: baseline; max-width: 400px; margin-left: auto; margin-right: auto">
                  <mat-form-field style="width: 42%">
                    <mat-label>{{ 'lasku.sposti-dialog.huomautuskulu' | translate | async }}</mat-label>
                    <input decimalNumberField matInput [formField]="kuluLomake.huomautuskulu" />
                    <mat-error>{{ fieldErrors().huomautuskulu }}</mat-error>
                  </mat-form-field>
                  <mat-checkbox style="margin-left: auto" [formField]="kuluLomake.viivastyskorko">{{ 'lasku.maksumuistutus.lisaa-korko' | translate | async }} ({{ korko | lmoney: data.kasiteltava?.valuutta | async }})</mat-checkbox>
                </div>
                <div class="huomautuskulun-ohje">{{ 'lasku.sposti-dialog.huomautuskulu-ohje' | translate | async }}</div>
              </form>
            </div>
          }
          <form novalidate style="margin-top: 1em">
            <div style="padding-bottom: 0.5em; min-height: 55px">
              <mat-chip-grid #vastaanottajaChips style="margin-bottom: 0.5em">
                @for (vastaanottaja of email.vastaanottajat; track vastaanottaja) {
                  <mat-chip-option [selectable]="false" [removable]="true" (removed)="poistaAsiakas(vastaanottaja)">
                    {{ vastaanottaja }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-option>
                }
              </mat-chip-grid>
            </div>
            <mat-form-field>
              <mat-label>{{ 'lasku.sposti-dialog.lisaavastaanottaja' | translate | async }}</mat-label>
              <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" cdkFocusRegionstart (blur)="lisaa()" [formField]="emailLomake.lisaavastaanottaja" (matChipInputTokenEnd)="lisaa()" matInput data-lpignore="true" />
              <mat-error>{{ fieldErrors().lisaavastaanottaja }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'lasku.sposti-dialog.aihe' | translate | async }}</mat-label>
              <input #aihe type="text" [formField]="emailLomake.aihe" matInput data-lpignore="true" />
              <mat-error>{{ fieldErrors().aihe }}</mat-error>
            </mat-form-field>
            <mat-form-field style="margin-top: 20px">
              <mat-label>{{ 'lasku.sposti-dialog.otsikko' | translate | async }}</mat-label>
              <input type="text" [formField]="emailLomake.otsikko" matInput data-lpignore="true" />
              <mat-error>{{ fieldErrors().otsikko }}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'lasku.sposti-dialog.teksti' | translate | async }}</mat-label>
              <textarea rows="2" [formField]="emailLomake.teksti" matInput cdkTextareaAutosize data-lpignore="true"></textarea>
              <mat-error>{{ fieldErrors().teksti }}</mat-error>
            </mat-form-field>
          </form>
          @if (asetuksissaOnOletustietojaVirhe) {
            <div class="red-text" style="margin-top: 1em; margin-bottom: 1em">
              {{ 'lasku.validation.asetukset.oletuksia-sposti' | translate | async }}
            </div>
          }
          <div style="display: flex; align-items: center; justify-content: center; margin: 2em 1em 2em">
            <div class="buttons-wrapper">
              @if (voikoAjastaa) {
                <div>
                  <button class="secondarybutton" mat-button (click)="ajasta()" [disabled]="!emailLomake().valid()">
                    {{ 'lasku.sposti-dialog.ajasta' | translate | async }}
                    @if (showNewFeatureSignObservable | async) {
                      <span class="uutta-sign ajasta-button-uutta-sign">{{ 'app.uutta' | translate | async }}</span>
                    }
                  </button>
                </div>
              }
              <button class="primarybutton" mat-button (click)="send()" [disabled]="!emailLomake().valid()">{{ 'lasku.sposti-dialog.laheta' | translate | async }}</button>
            </div>
          </div>
        </div>
        <div class="keskitettava">
          <div style="margin: 0; font-size: 15px" class="light-blue-text">{{ 'lasku.sposti-dialog.esikatselu' | translate | async }}</div>
          <lasku-email-esikatselu-perinteinen [tiedot]="esikatselutiedot | async"></lasku-email-esikatselu-perinteinen>
        </div>
      </div>
    </div>
  }

  @if (aktiivinenValilehti == 1) {
    <div class="sisalto">
      <div class="containerii">
        <div class="keskitettava">
          <div class="light-blue-text otsikko">{{ 'lasku.laheta-comp.sahkoinen.otsikko' | translate | async }}</div>
          <div class="light-gray-text ohjeteksti">
            {{ 'lasku.laheta-comp.sahkoinen.' + infotekstinAvain | translate | async }}
          </div>
          @if (onkoMuistutus && !onkoUudelleenlahetys) {
            <div style="padding-bottom: 1em">
              <form>
                <div style="display: flex; flex-flow: row wrap; justify-content: left; align-items: baseline; max-width: 400px; margin-left: auto; margin-right: auto">
                  <mat-form-field style="width: 42%">
                    <mat-label>{{ 'lasku.sposti-dialog.huomautuskulu' | translate | async }}</mat-label>
                    <input decimalNumberField matInput [formField]="kuluLomake.huomautuskulu" />
                    <mat-error>{{ fieldErrors().huomautuskulu }}</mat-error>
                  </mat-form-field>
                  <mat-checkbox style="margin-left: auto" [formField]="kuluLomake.viivastyskorko">{{ 'lasku.maksumuistutus.lisaa-korko' | translate | async }} ({{ korko | lmoney: data.kasiteltava?.valuutta | async }})</mat-checkbox>
                </div>
                <div class="huomautuskulun-ohje">{{ 'lasku.sposti-dialog.huomautuskulu-ohje' | translate | async }}</div>
              </form>
            </div>
          }
          <form novalidate style="margin-top: 1em; max-width: 400px; margin-left: auto; margin-right: auto">
            <mat-form-field>
              <mat-label>{{ 'lasku.sposti-dialog.verkkolasku.valittajatunnus' | translate | async }}</mat-label>
              <mat-select [formField]="sahkoinenLomake.valittaja">
                @for (operator of verkkolaskuoperaattorit; track operator) {
                  <mat-option [value]="operator.tunnus"> {{ operator.nimi }} ({{ operator.tunnus }}) </mat-option>
                }
              </mat-select>
              @if (onkoVirhe(sahkoinenLomake.valittaja, 'required') && (sahkoinenLomake.valittaja().dirty() || sahkoinenLomake.valittaja().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.valittaja.required' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{ 'lasku.sposti-dialog.verkkolasku.osoite' | translate | async }}</mat-label>
              <input type="text" [formField]="sahkoinenLomake.osoite" matInput data-lpignore="true" />
              @if (peppolValidationObservable | async; as peppolMessage) {
                <mat-hint>{{ peppolMessage.message }}</mat-hint>
              }
              @if (onkoVirhe(sahkoinenLomake.osoite, 'minLength') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.minlength' | translate | async }}</mat-error>
              }
              @if (onkoVirhe(sahkoinenLomake.osoite, 'required') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.required' | translate | async }}</mat-error>
              }
              @if (onkoVirhe(sahkoinenLomake.osoite, 'valittaja') && (sahkoinenLomake.osoite().dirty() || sahkoinenLomake.osoite().touched())) {
                <mat-error>{{ 'lasku.laheta-comp.sahkoinen.validation.osoite.valittaja' | translate | async }}</mat-error>
              }
            </mat-form-field>
            <!-- <div style="margin-top: 4em;">
            <div>Verkkolaskuosoite hukassa?</div>
            <mat-form-field> -->
            <!-- 'lasku.sposti-dialog.verkkolasku.ytunnus' | translate | async -->
            <!-- <mat-label>{{ 'Etsi y-tunnuksella' }}</mat-label>
              <input type="text" formControlName="ytunnus"  matInput />
              <mat-hint>{{osoitehaunHintTeksti}}</mat-hint>
              <mat-error>{{fieldErrors().ytunnus}}</mat-error>
            </mat-form-field>
            @if (osoitehaunTulokset) {
              <div>
                <div>Löytyneet verkkolaskuosoitteet</div>
                @for (tulos of osoitehaunTulokset; track tulos) {
                  <div [innerHtml]="tulos | ljson"></div>
                }
              </div>
            }
          </div> -->
          </form>
          @if (asetuksissaOnOletustietojaVirhe) {
            <div class="red-text" style="margin-top: 1em; margin-bottom: 1em">
              {{ 'lasku.validation.asetukset.oletuksia-sposti' | translate | async }}
            </div>
          }
          <div style="display: flex; align-items: center; justify-content: center; margin: 2em 1em 2em">
            <div class="buttons-wrapper">
              @if (voikoAjastaa) {
                <div>
                  <button class="secondarybutton" mat-button (click)="ajasta()">
                    {{ 'lasku.sposti-dialog.ajasta' | translate | async }}
                    @if (showNewFeatureSignObservable | async) {
                      <span class="uutta-sign ajasta-button-uutta-sign">{{ 'app.uutta' | translate | async }}</span>
                    }
                  </button>
                </div>
              }
              <button class="primarybutton" mat-button (click)="lahetaSahkoinen()">{{ 'lasku.sposti-dialog.laheta' | translate | async }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (aktiivinenValilehti == 2) {
    <div class="sisalto">
      <div class="containerii">
        <div class="keskitettava">
          <div class="light-blue-text otsikko">{{ 'lasku.laheta-comp.itse.otsikko' | translate | async }}</div>
          <div class="light-gray-text ohjeteksti">
            {{ 'lasku.laheta-comp.itse.' + infotekstinAvain | translate | async }}
          </div>
          @if (onkoMuistutus && !onkoUudelleenlahetys) {
            <div style="padding-bottom: 1em">
              <form>
                <div style="display: flex; flex-flow: row wrap; justify-content: left; align-items: baseline; max-width: 400px; margin-left: auto; margin-right: auto">
                  <mat-form-field style="width: 42%">
                    <mat-label>{{ 'lasku.sposti-dialog.huomautuskulu' | translate | async }}</mat-label>
                    <input decimalNumberField matInput [formField]="kuluLomake.huomautuskulu" />
                    <mat-error>{{ fieldErrors().huomautuskulu }}</mat-error>
                  </mat-form-field>
                  <mat-checkbox style="margin-left: auto" [formField]="kuluLomake.viivastyskorko">{{ 'lasku.maksumuistutus.lisaa-korko' | translate | async }} ({{ korko | lmoney: data.kasiteltava?.valuutta | async }})</mat-checkbox>
                </div>
                <div class="huomautuskulun-ohje">{{ 'lasku.sposti-dialog.huomautuskulu-ohje' | translate | async }}</div>
              </form>
            </div>
          }
          @if (asetuksissaOnOletustietojaVirhe) {
            <div class="red-text" style="margin-top: 1em; margin-bottom: 1em; width: 100%; text-align: center">
              {{ 'lasku.validation.asetukset.oletuksia-sposti' | translate | async }}
            </div>
          }
          <div style="display: flex; align-items: center; justify-content: center; margin: 2em 1em 2em">
            <div class="buttons-wrapper">
              @if (voikoAjastaa) {
                <div>
                  <button class="secondarybutton" mat-button (click)="ajasta()">
                    {{ 'lasku.sposti-dialog.ajasta' | translate | async }}
                    @if (showNewFeatureSignObservable | async) {
                      <span class="uutta-sign ajasta-button-uutta-sign">{{ 'app.uutta' | translate | async }}</span>
                    }
                  </button>
                </div>
              }
              <button class="primarybutton" mat-button (click)="saveAndPrint()" type="button">
                {{ 'lasku.sposti-dialog.itse.lataa' | translate | async }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
